import React from 'react';

interface CardProps {
  children: React.ReactNode;
  title?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  /** Remove inner padding (e.g. for edge-to-edge tables). */
  flush?: boolean;
}

const Card: React.FC<CardProps> = ({ children, title, actions, className = '', flush = false }) => (
  <section
    className={`rounded-2xl border border-school-line bg-school-surface shadow-[0_1px_3px_rgba(20,33,61,0.06)] ${className}`}
  >
    {(title || actions) && (
      <header className="flex items-center justify-between gap-3 px-5 pt-5">
        {title && <h2 className="text-lg font-bold text-school-ink">{title}</h2>}
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </header>
    )}
    <div className={flush ? 'pt-3' : 'p-5'}>{children}</div>
  </section>
);

export default Card;
